import { getCookie, setCookie } from '@/utils/Application/cookies';

export const GATOR_PROTECT_NO_THREATS_MODAL_WEEKLY_COOKIE = 'hg-gator-protect-no-threats-modal-dismissed-at';

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isNoThreatsCookieExpired(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  const raw = getCookie(GATOR_PROTECT_NO_THREATS_MODAL_WEEKLY_COOKIE);
  if (raw == null || raw === '') {
    return false;
  }
  const ts = Number(raw);
  if (!Number.isFinite(ts)) {
    return false;
  }
  return Date.now() - ts < WEEK_MS;
}

export function recordNoThreatsCookie(): void {
  if (typeof document === 'undefined') {
    return;
  }
  setCookie(GATOR_PROTECT_NO_THREATS_MODAL_WEEKLY_COOKIE, String(Date.now()), true, 7);
}
